import { render, staticRenderFns } from "./OtherLink.vue?vue&type=template&id=5ed5eec3&scoped=true"
import script from "./OtherLink.vue?vue&type=script&lang=js"
export * from "./OtherLink.vue?vue&type=script&lang=js"
import style0 from "./OtherLink.vue?vue&type=style&index=0&id=5ed5eec3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed5eec3",
  null
  
)

export default component.exports